import React from 'react';
import { DeviceDetailPage } from '../../../../components/DeviceDetailPage';
import { useAppRoute } from '../../../../hooks/app-route-hooks';

export const DevicesLocationDeviceDetails: React.FC = () => {
    const currentAppRoute = useAppRoute('DevicesLocationDeviceDetails');

    return (
        <DeviceDetailPage
            testId="device-location-device-details-page"
            appRoute={{
                type: 'DevicesLocation',
                locationId: currentAppRoute.locationId,
            }}
        />
    );
};
